import { define } from '@rlean/core';

const FormDataCount = define('formData', {
  nullableParams: true,
  getURL: '/FormDataCount',
});

export default FormDataCount;
